import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import InputForm from '../../../../../components/form/InputForm';
import SearchAddress from '../../../../../components/SearchAddress';
import TextArea from '../../../../../components/input/TextArea';
import { INVALID_MOBILE_PHONE_MESSAGE } from '../../../../../constants/service/invalidMsg/commonInvalidMsg';
import {
  MAXIMUM_NUMBER_OF_RECIPIENT_NAME_TEXT,
  MAXIMUM_NUMBER_OF_SHIPPING_MESSAGE_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { setPhoneFormat } from '../../../../../lib/common';
import { REX_PHONE } from '../../../../../lib/rex';
import { formRequiredRules } from '../../../../../lib/formRules';
import './EditBuyerInfoModal.scss';

const EditBuyerInfoModal = (props) => {
  const {
    isOpen,
    form,
    onSubmit,
    setData,
    setShippingAddress,
    closeModal,
    recipientName,
    recipientPhone,
    shippingAddress,
    shippingMessage,
    isGiftReady,
  } = props;

  return (
    <Modal
      title="주문자 정보 수정"
      isOpen={isOpen}
      width={600}
      height={500}
      isFooter={true}
      okText="변경"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="edit-buyer-info-modal-wrap">
        <div className="edit-buyer-info">
          <div>
            {isGiftReady
              ? '* 입력하신 내용으로 선물 배송지가 업데이트되며 선물 수락 상태로 변경됩니다.'
              : '* 입력하신 내용으로 배송지 정보가 변경됩니다.'}
          </div>
        </div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">수취인명</td>
              <td className="tl" colSpan={3}>
                <InputForm
                  form={form}
                  name="recipientName"
                  rules={[formRequiredRules(true, null)]}
                  maxLength={MAXIMUM_NUMBER_OF_RECIPIENT_NAME_TEXT}
                  initialValue={recipientName}
                  onChange={(value) =>
                    setData({
                      name: 'recipientName',
                      value,
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">수취인 연락처</td>
              <td className="tl" colSpan={3}>
                <InputForm
                  form={form}
                  name="recipientPhone"
                  rules={[formRequiredRules(true, null), { pattern: REX_PHONE, message: INVALID_MOBILE_PHONE_MESSAGE }]}
                  getValueFromEvent={(value) => setPhoneFormat(value)}
                  initialValue={recipientPhone ? setPhoneFormat(recipientPhone) : null}
                  onChange={(value) =>
                    setData({
                      name: 'recipientPhone',
                      value,
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">
                <span>배송지 주소</span>
              </td>
              <td className="tl" colSpan={3}>
                <div>
                  <SearchAddress
                    address={shippingAddress}
                    onSelect={(address) =>
                      setShippingAddress({
                        name: 'shippingAddress',
                        value: address,
                      })
                    }
                  />
                  <InputForm
                    form={form}
                    name="address-line2"
                    rules={[formRequiredRules(true, undefined, true)]}
                    initialValue={shippingAddress.line2}
                    onChange={(value) =>
                      setShippingAddress({
                        name: 'shippingAddress',
                        value: {
                          line2: value,
                        },
                      })
                    }
                    placeholder="상세 주소"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="label tc">배송 시 요청사항</td>
              <td className="tl" colSpan={3}>
                <TextArea
                  maxLength={MAXIMUM_NUMBER_OF_SHIPPING_MESSAGE_TEXT}
                  value={shippingMessage}
                  onChange={(value) =>
                    setData({
                      name: 'shippingMessage',
                      value,
                    })
                  }
                />
                <div className="sub-info">
                  <div>* 구매자와 협의 후 내용을 작성해주세요. (최대 50자)</div>
                  <div>* 작성하신 내용은 구매자에게 보여집니다. (아몬즈 앱에 노출)</div>
                </div>
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default EditBuyerInfoModal;
